import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "legendItem"]
  static values = {
    activeFilter: { type: String, default: "" },
    missionId: String
  }

  filter(event) {
    event.preventDefault()
    const status = event.params.status

    if (this.activeFilterValue === status) {
      this.activeFilterValue = ""
      this.clearHighlight()
      this.updateResponseFrame("")
    } else {
      this.activeFilterValue = status
      this.highlightGroup(status)
      this.updateResponseFrame(status)
    }
  }

  highlightGroup(status) {
    this.element.querySelectorAll("[data-review-status]").forEach(dot => {
      if (dot.dataset.reviewStatus === status) {
        dot.classList.remove("opacity-30")
        dot.classList.add("opacity-100", "ring-1", "ring-offset-1")
      } else {
        dot.classList.remove("opacity-100", "ring-1", "ring-offset-1")
        dot.classList.add("opacity-30")
      }
    })

    this.legendItemTargets.forEach(item => {
      if (item.dataset.reviewWaffleChartStatusParam === status) {
        item.classList.add("font-semibold")
        item.classList.remove("text-gray-500")
      } else {
        item.classList.remove("font-semibold")
        item.classList.add("text-gray-500")
      }
    })
  }

  clearHighlight() {
    this.element.querySelectorAll("[data-review-status]").forEach(dot => {
      dot.classList.remove("opacity-30", "ring-1", "ring-offset-1")
      dot.classList.add("opacity-100")
    })

    this.legendItemTargets.forEach(item => {
      item.classList.remove("font-semibold", "text-gray-500")
    })
  }

  showLoading() {
    this.element.classList.add("cursor-wait")
  }

  clearLoading() {
    document.querySelectorAll("[data-controller*='review-waffle-chart']").forEach(el => {
      el.classList.remove("cursor-wait")
    })
  }

  updateResponseFrame(reviewStatus) {
    this.showLoading()

    // Activate the Responses tab so the panel and turbo frame are visible
    const responsesTab = document.querySelector('[data-tab="mission-responses"]')
    if (responsesTab) responsesTab.click()

    setTimeout(() => {
      const frame = document.querySelector(`turbo-frame[id$="_responses"]`)
      if (!frame) {
        this.clearLoading()
        return
      }

      // Listen for this specific frame to finish loading, then clear
      const onLoad = () => {
        frame.removeEventListener("turbo:frame-load", onLoad)
        this.clearLoading()
      }
      frame.addEventListener("turbo:frame-load", onLoad)

      const baseUrl = `/missions/${this.missionIdValue}/responses`
      const params = new URLSearchParams()
      params.set("format", "turbo_stream")

      if (reviewStatus) {
        params.append("q[review_status_in][]", reviewStatus)
        params.set("q[status_eq]", "ended")
      }

      frame.src = `${baseUrl}?${params.toString()}`
    }, 100)
  }
}
